import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import { useEffect } from 'react';
function Dashboard() {
   useEffect(() => {
    window.scrollTo(0, 10);
  }, []);

  return (
    <div>
      <Navbar />
      <div className="container py-5">
        <h2 className="font-josefin font-light text-4xl text-uppercase text-center mb-4">
          DASHBOARD
        </h2>
        <div className="row row-cols-1 row-cols-sm-2 row-cols-lg-3 g-4">
          {['Project Overview', 'User Analytics', 'Settings'].map((item, index) => (
            <div key={index} className="col">
              <div className="card h-100">
                <div className="card-body">
                  <h3 className="font-josefin font-light text-xl mb-2">{item}</h3>
                  <p className="text-secondary">Manage your {item.toLowerCase()} here.</p>
                  <button className="btn btn-dark">View Details</button>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
      <Footer />
    </div>
  );
}

export default Dashboard;